import { RulerGreenIcon, RulerGreyIcon } from '@/components/ui/icons'
import { memo, useMemo } from 'react'
import Image from 'next/image'
import CharityApartmentMock from '../../../../public/img/png/charityApartmentMock.png'
import styles from './styles.module.css'

const ImageWithPercents = ({ image, cost, raised, rate = 1 }) => {
  const percent = useMemo(() => Math.floor((raised / rate / cost) * 100), [raised, cost, rate])
  const topPercent = useMemo(() => 100 - percent, [percent])
  const percentCondition = useMemo(() => {
    return percent >= 100 ? 100 : percent
  }, [percent])

  const imageContainerClass = `${styles.imageContainer} ${!image ? styles.noImage : ''}`
  const topClass = `${styles.top} ${topPercent !== 0 ? styles.hasOpacity : ''} ${
    percentCondition === 100 ? styles.fullPercent : ''
  }`
  const percentClass = `${styles.percent} ${
    percentCondition === 100 ? styles.fullBg : styles.normalBg
  }`

  return (
    <div className={imageContainerClass}>
      <Image
        className={styles.imageWrapper}
        layout={image ? 'fill' : 'fixed'}
        src={image || CharityApartmentMock}
        unoptimized
        alt="apartment"
      />
      <div className={topClass} style={{ height: topPercent ? `${topPercent}%` : '100%' }} />
      <div
        className={styles.bottom}
        style={{ height: percentCondition ? `${percentCondition}%` : '0%' }}
      >
        <div className={percentClass}>{percentCondition}%</div>
      </div>
      <div className={styles.ruler}>
        <div
          className={styles.greyWrapper}
          style={{ height: topPercent ? `${topPercent}%` : '100%' }}
        >
          <RulerGreyIcon />
        </div>
        <div
          className={styles.greenWrapper}
          style={{ height: percentCondition ? `${percentCondition}%` : '0%' }}
        >
          <RulerGreenIcon />
        </div>
      </div>
    </div>
  )
}

export default memo(ImageWithPercents)
